import axiosClient from "../api/axiosClient";
import { decryptedAdminID } from "../utility";

// export const getCandidateDetails = async (id,params) => {
//   const response = await axiosClient.get(`/getCandidateDetails`, {
    
//     params
//   });

//   return response.data;
// };  

export const getCandidateDetails = async (id, type, isLead = false) => {

  const params = isLead
    ? { can_lead_id: id, type }
    : { candidate_id: id, type };

  const response = await axiosClient.get(`/getCandidateDetails`, {
    params
  });

  return response.data;
};

export const getReasons = async (stageGroup) => {
  const response = await axiosClient.get("/getPipelineReasons", {
    params: {
      stage_group: stageGroup,
    },
  });

  return response.data;
};

export const getAdminIds = async (obj) => {
  const body = {
    memberId: obj.id,
  onlyMe:obj.onlyMe
  };

  const { data } = await axiosClient.post("/teamScope", body);

  return data;
};

export const getCandidateTimeline = async (obj) => {
  const response = await axiosClient.get("/getCandidateTimeline", {
    params: {
      can_id: obj.candidate_id,
      event_type : obj.event_type,
      page: obj.page,
      size:obj.size
    },
  });

  return response.data;
};


export const getCandidateNotes = ({ can_id, can_lead_id }) => {
  return axiosClient.get(`/getCandidateNotes`, {
    params: { can_id, can_lead_id },
  });
};

export const createCandidateNotes = (data) => {
  return axiosClient.post(`/createCandidateNotes`, data);
};

export const uploadCandidateResume = async (
  candidateId,
  file
) => {
  const adminID = decryptedAdminID();

  const formData = new FormData();
  formData.append("file", file);

  return axiosClient.post(
    `/updateCandidateDocument`,
    formData,
    {
      params: {
        canId: candidateId,
        docType: "Resume",  
        adminId: adminID,
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
}

export const updateCandidate = ({ can_id, data }) => {
  const adminID = decryptedAdminID();
  return axiosClient.put(
    `/candidate/update/${adminID}`,
    data, 
    {
      params: { can_id },
    }
  );
};